import React from 'react';
import { Link } from 'react-router-dom';
import './Brand.css';

// A crisp, single-color interpretation of the existing TM monogram.
export default function BrandLogo() {
  return (
    <Link to="/home" className="tm-brand" aria-label="TokenizeMe home">
      <svg width="34" height="34" viewBox="0 0 40 40" aria-hidden="true">
        <rect width="40" height="40" rx="9" fill="currentColor" />
        <path
          d="M10 10h20v5h-7v7l-3-3-3 3v-7h-7zM10 19l10 9 10-9v12h-5v-3l-5 4-5-4v3h-5z"
          fill="#fff"
        />
      </svg>
      <span>
        TokenizeMe<span className="tm-brand-dot">.</span>
      </span>
    </Link>
  );
}
